<template>
	<div class="toplink">
		<img src="../../assets/images/liaotianjiqiren.png" @click="handleLinkClick"/>
		<div id="dialog">
			<div @click="handleLinkClick">
				<div class="text">批量采购，请联系我</div>
				<el-button type="primary" size="small">知道啦</el-button>
			</div>
			<div v-if="linkQrcodeVisable" id="linkQrcode">
				<i @click="handleCloseLinkClick" class="el-icon-circle-close close-btn"></i>
				<div>请使用微信扫一扫<br />添加客服微信</div>
				<img src="../../assets/images/wangshaohong_qrcode.png" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				linkQrcodeVisable: false
			}
		},
		mounted() {
			this.initEvent()
		},
		methods: {
			initEvent() {
				var that = this
				that.showLinkQrcode()
				setTimeout(() => {
					if (!this.linkQrcodeVisable) {
						that.showLinkQrcode()
					}
				}, 1000 * 2)
			},
			showLinkQrcode() {
				for (var i = 0; i < 10; i++) {
					let index = i;
					setTimeout(() => {
						this.linkQrcodeVisable = (index % 2 == 0)
					}, 9000 + index * 300)
				}
			},
			handleLinkClick() {
				this.linkQrcodeVisable = true;
			},
			handleCloseLinkClick() {
				this.linkQrcodeVisable = false;
			}
		}
	}
</script>

<style lang="scss">
	.toplink {
		position: fixed;
		width: 400px;
		height: 400px;
		top: 200px;
		right: -15px;
	
		img {
			position: absolute;
			right: 0;
			display: block;
			width: 185px;
			height: 185px;
		}
	
		#dialog {
			top: 240px;
			right: 140px;
			padding: 10px;
			width: 160px;
			height: 80px;
			background-color: #fff;
			position: fixed;
			border: 1px solid #0f97ff;
			border-radius: 5%;
			color: #0f97ff;
	
			.text {
				margin-bottom: 20px;
			}
	
			&::after {
				border: solid 1px transparent;
				content: ' ';
				height: 0;
				left: 100%;
				position: absolute;
				width: 0;
				border-width: 8px;
				border-left-color: #fff;
				top: 14px;
			}
	
			&::before {
				border: solid 1px transparent;
				content: ' ';
				height: 0;
				left: 100%;
				position: absolute;
				width: 0;
				border-width: 11px;
				border-left-color: #0f97ff;
				top: 10px;
			}
		}
	
		#linkQrcode {
			padding: 20px 40px;
			width: 180px;
			height: 260px;
			position: fixed;
			top: 200px;
			right: 140px;
			background: #fff;
			color: #333;
			border: solid 1px #0f97ff;
	
			img {
				position: relative;
				margin-top: 20px;
				width: 180px;
				height: 180px;
				z-index: 1000;
			}
	
			.close-btn {
				color: #0f97ff;
				font-size: 30px;
				font-weight: 200;
				position: absolute;
				top: -20px;
				right: -30px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/toplink/index.vue